import { ButtonMui } from 'src/components/ButtonMui'
import * as S from './ButtonCreateDock.styles'

interface ButtonCreateDockProps {
    setOpenModalCreateDock: (isOpen: boolean) => void
}

const ButtonCreateDock = ({ setOpenModalCreateDock }: ButtonCreateDockProps) => (
  <S.ButtonContainer>
    <ButtonMui
      onClick={() => setOpenModalCreateDock(true)}
      testId='button-create-dock'
      bgColor='darkBlue'
      hoverColor='darkBlueHover'
      letterColor='white'
      title={(
        <>
          <S.HouseIcon />
          Cadastrar nova doca
        </>
    )}
    />

  </S.ButtonContainer>
)

export default ButtonCreateDock
